var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8501 6.15761C63.3301 1.47842 58.3043 -1.08215 53.6259 0.438637C48.9467 1.95864 46.3861 6.98444 47.9069 11.6629L70.9403 82.5307C72.522 86.902 77.2438 89.3583 81.7765 88.054C86.5045 86.693 89.3863 81.6715 87.8776 77.0282L64.8501 6.15761Z",
    fill: "#DFA22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1601 17.7543C27.6393 13.0755 22.6139 10.5149 17.9355 12.0349C13.2559 13.5553 10.6949 18.5807 12.2161 23.2599L35.2499 94.1282C36.8313 98.4991 41.5534 100.956 46.0861 99.6503C50.8138 98.2901 53.6955 93.2686 52.1868 88.6245L29.1601 17.7543Z",
    fill: "#3CB187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8426 64.8507C98.5218 63.3307 101.082 58.3057 99.5616 53.6261C98.0416 48.9477 93.0158 46.3868 88.3374 47.9072L17.4695 70.9413C13.0982 72.5223 10.642 77.2441 11.9463 81.7767C13.3072 86.5044 18.3287 89.3866 22.972 87.8779L93.8426 64.8511",
    fill: "#CE1E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2396 84.8668L49.1773 79.3635L43.6733 62.4238L26.7344 67.9295L32.2396 84.8668Z",
    fill: "#392538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9304 73.2703C74.334 71.1904 80.2859 69.2562 84.8686 67.767L79.3637 50.8242L62.4248 56.3298L67.9304 73.2703Z",
    fill: "#BB242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.246 29.1596C86.9248 27.6396 89.4854 22.6142 87.9654 17.9346C86.4454 13.2562 81.4196 10.6956 76.7404 12.2156L5.87213 35.2502C1.50123 36.8303 -0.955398 41.5525 0.350088 46.0852C1.71028 50.8125 6.73177 53.6946 11.3758 52.1859L82.246 29.1596Z",
    fill: "#72C5CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6399 49.1771C25.2527 47.6782 31.1999 45.7456 37.5804 43.6731C35.5004 37.2687 33.5662 31.3169 32.0771 26.7334L15.1343 32.2398L20.6399 49.1771Z",
    fill: "#248C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3303 37.5805L73.2716 32.0756C71.4367 26.4279 69.6017 20.7803 67.7663 15.1328L50.8247 20.6392L56.3303 37.5805Z",
    fill: "#62803A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.78c41dd85303838f073e065aad60f7bc.svg";
export { ForwardRef as ReactComponent };